<template>
  <div class="search-driver-meter">
    <div v-cloak class="right_col" role="main">
      <el-row :gutter="20">
        <el-col :span="24">
          <h3>查詢跳錶紀錄</h3>
          <hr />
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <h4 class="col-md-1">起始時間：</h4>
          <DateSelect ref="startTime" />
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <h4 class="col-md-1">結束時間：</h4>
          <DateSelect ref="endTime" :isEndTime="true"></DateSelect>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="2">
          <h4>司機呼號:</h4>
        </el-col>
        <el-col :span="5">
          <el-autocomplete
            v-model="autoValue"
            :fetch-suggestions="querySearchAsync"
            placeholder="請輸入隊編/呼號"
            @select="handleSelect"
          />
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="onSearch" :loading="loading">
            搜尋
          </el-button>
        </el-col>
      </el-row>
      <!--表格-->
      <el-row :gutter="20">
        <el-col :offset="2" :span="20">
          <el-table
            v-loading="loading"
            :data="taxiMeterList"
            style="width: 100%"
          >
            <el-table-column prop="driver" label="呼號/司機姓名" />
            <el-table-column prop="pickUpTime" label="載客時間" />
            <el-table-column prop="createdAt" label="付款時間" />
            <el-table-column prop="fare" label="跳錶金額" />
          </el-table>
          <el-pagination
            v-if="paging.totalPages !== 1"
            background
            layout="prev, pager, next"
            :page-count="paging.totalPages || 1"
            :page-size="paging.perPage"
            :current-page.sync="paging.currentPage"
            :total="paging.totalEntries"
            class="d-inline-block"
            @current-change="onCurrentChange"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { reqDriverList, reqTaxiMeter } from '@/api/searchDriverMeter'
import DateSelect from '../../components/tool/DateSelect'
import { Notification } from 'element-ui'
import dayjs from 'dayjs'

export default {
  components: {
    DateSelect,
  },
  data() {
    return {
      taxiMeterList: [],
      paging: {
        currentPage: 1,
        npp: 25,
        totalPages: 1,
        totalEntries: null,
      },
      loading: false,
      driverId: null,
      callNumber: null,
      autoValue: '',
    }
  },
  methods: {
    querySearchAsync(queryString, cb) {
      const driverList = this.driverList
      const results = queryString
        ? driverList.filter(this.driverFilter(queryString))
        : driverList
      clearTimeout(this.timeout)
      const array = results.map((element) => {
        return {
          value: `${element.call_number}- ${element.name}`,
          id: element.id,
          callNumber: element.call_number,
          phone: element.phone,
        }
      })
      this.timeout = setTimeout(() => {
        cb(array)
      }, 3000 * Math.random())
    },
    driverFilter(queryString) {
      return (state) => {
        return (
          state.call_number.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    handleSelect({ id, callNumber }) {
      this.driverId = id
      this.callNumber = callNumber
    },
    async fetchDriverList() {
      try {
        const { driverList } = await reqDriverList()
        this.driverList = driverList
      } catch (e) {
        console.error(e)
      }
    },
    async onSearch(_, currentPage = 1) {
      if (!this.callNumber) {
        Notification({
          title: '請選擇司機呼號',
          type: 'warning',
        })
      } else {
        try {
          this.loading = true
          const start = this.getUTCtime(this.$refs.startTime.getDate())
          const end = this.getUTCtime(this.$refs.endTime.getDate())
          const {
            result: { data, paging },
          } = await reqTaxiMeter({
            call_number: this.callNumber,
            start_date: start,
            end_date: end,
            current_page: currentPage,
            per_page: this.paging.npp,
          })
          this.paging = {
            currentPage: paging.currentPage,
            npp: paging.perPage,
            totalPages: paging.totalPages,
            totalEntries: paging.totalEntries,
          }
          this.taxiMeterList = data.map(
            ({ driverCallNumber, driverName, pickUpTime, createdAt, fare }) => {
              return {
                driver: `${driverCallNumber} / ${driverName}`,
                createdAt: this.getLocalTime(createdAt),
                pickUpTime: this.getLocalTime(pickUpTime),
                fare: fare,
              }
            },
          )
        } catch (e) {
          console.error(e)
        } finally {
          this.loading = false
        }
      }
    },
    onCurrentChange(currentPage) {
      this.paging.currentPage = currentPage
      this.onSearch(_, currentPage)
    },
    getUTCtime(time) {
      return dayjs(time).subtract(8, 'hours').format('YYYY-MM-DD HH:mm:ss')
    },
    getLocalTime(time) {
      if (time) {
        return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
      }
      return ''
    },
  },
  mounted() {
    this.fetchDriverList()
  },
}
</script>
<style scoped>
.search-driver-meter .el-table .warning-row {
  background: oldlace;
}

.search-driver-meter .el-row {
  margin-bottom: 20px;
}

.search-driver-meter .el-table .success-row {
  background: #f0f9eb;
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/SearchDriverMeter.vue